import type { Icon } from "@phosphor-icons/react"

export function PagePlaceholder({
  title,
  description,
  icon: PlaceholderIcon,
}: {
  title: string
  description: string
  icon: Icon
}) {
  return (
    <div className="flex flex-1 flex-col gap-6 p-6">
      <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
      <div className="flex flex-1 flex-col items-center justify-center gap-3 text-center">
        <div className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <PlaceholderIcon size={24} aria-hidden />
        </div>
        <p className="max-w-xs text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  )
}
